import React, { useState } from "react";

import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import connect from "react-redux/es/connect/connect";
import Bestof from "./BestOf/BestOf";
import StatsPoc from "./Stats/Stats.poc";
import PowerBi from "./PowerBi";

const screenWidth = window.innerWidth;

const Button = ({ openModal, children }) => {
  return (
    <div
      onClick={openModal}
      style={{
        height: 50,
        borderRadius: 25,
        backgroundColor: "#E46901",
        color: "white",
        width: "80%",
        textAlign: "center",
        verticalAlign: "center",
        padding: 20,
        cursor: "pointer",
        margin: 10,
        marginTop: 40
      }}
    >
      {children}
    </div>
  );
};
const Poc = () => {
  const [bestOfIsVisible, setBestOfIsVisible] = useState(false);
  const [statsClientIsVisible, setStatsClientIsVisible] = useState(false);
  const [powerBiIsVisible, setPowerBiIsVisible] = useState(false);

  return (
    <div style={{ width: screenWidth }}>
      <div style={{ fontSize: 30 }}>Liste des POCS</div>
      <ul style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Button openModal={() => setBestOfIsVisible(true)}>Photos Best Of Mobile</Button>
        <Button openModal={() => setStatsClientIsVisible(true)}>Stats clients Mobile</Button>
        <Button openModal={() => setPowerBiIsVisible(true)}>PowerBI</Button>
      </ul>

      {bestOfIsVisible && <Bestof closeModal={() => setBestOfIsVisible(false)} />}
      {statsClientIsVisible && <StatsPoc closeModal={() => setStatsClientIsVisible(false)} />}
      {powerBiIsVisible && <PowerBi></PowerBi>}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    setMenuLeftContent: content => {
      dispatch(setMenuLeftContent(content));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Poc);



// WEBPACK FOOTER //
// src/pages/admin/poc/Home.poc.js